export function ContactDetails({
  className = '',
  inline = false,
}: {
  className?: string;
  inline?: boolean;
}) {
  return (
    <div
      className={`chunkzters-contact ${inline ? 'chunkzters-contact--inline' : ''} ${className}`.trim()}
    >
      <a href="tel:+441274082313" className="chunkzters-contact-phone">
        <i className="bi bi-telephone" aria-hidden />
        01274 082313
      </a>
      <address className="chunkzters-contact-address mb-0">
        {inline ? (
          <>UNIT 23, Mount Street, Bradford, BD3 9SW</>
        ) : (
          <>
            UNIT 23, Mount Street,
            <br />
            Bradford, BD3 9SW
          </>
        )}
      </address>
    </div>
  );
}
